import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';

import Button from '@swf/components/StarsButton/StarsButton';
import type { Dispatch } from '@swf/core/store';
import { PokerModalRoutes } from '@swf/core/types/Poker';
import { useGetWidgetState } from '@swf/poker';

import { TXTCLI_Create_Tournament } from './CreateTournamentButton.messages.json';
import styles from './CreateTournamentButton.scss';

const CreateTournamentButton = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const { modal } = useDispatch<Dispatch>();
  const data = useGetWidgetState();
  const handleClick = () =>
    modal.enqueue({ path: PokerModalRoutes.createTournament, locationState: { ...data, clubId } });

  return (
    <Button
      className={styles.button}
      translation={TXTCLI_Create_Tournament}
      onClick={handleClick}
    />
  );
};

export default CreateTournamentButton;
